import React, { useMemo } from 'react';
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import orderApi from '../../api/OrderApi';
import saveCardDetails from '../../api/saveCardDetails';
import { CLEARALLORDER } from '../../redux/features/AllOrder';
import { CLEARCART } from '../../redux/features/CartData';
import { SETLOADER } from '../../redux/features/common';
import { paymentElementOptions } from '../../utils/payment/PaymentContant';
import ParseFloat from '../../utils/ParseFloat';
import useAllCharges from '../../hooks/AllCharge';
// import store from "../../redux";
import { getCurrentTime, IsNullUndefine } from '../../utils/helper';
import { CLEARCHECKOUTADDRESS } from '../../redux/features/CheckoutAddress';
import LoaderButton from '../Buttons/LoaderButton';
import { resetScheduleDeivery } from '../../redux/features/CheckoutAddress';
import Konsole from '../../utils/konsole/Konsole';
import { useTranslation } from 'react-i18next';
import GlobalButton from '../Buttons/btn2/GlobalButton';
const StripePayment = ({ stripeConnectedId }: any) => {
  const { t } = useTranslation()
  const [taxes, discount, service_charge, remaining_amount, totalPrice,totalPriceNotUsed,deliveryChargeNotUsed,card_fees] =
    useAllCharges();
  const stripe: any = useStripe();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { items, itemCount } = useSelector((state: any) => state?.cartData);
  const reduxStoreData = useSelector((state: any) => state);
  const {
    checkoutAddress: {
      selectedAddress: {
        latitude, lattitude, longitude, full_address, house_no,
        zip_code, id, street_name,
      },
      selectedPickupDate: { date, day },
      selectedPickupTime, deliveryScheduleType, deliveryInstruction, deliveryNotes,
    },
    store: { selectedType },
    cartData: { commissionFee, deliveryCharge, discountAmount },
    userData: {
      user: { first_name, last_name, iso_code, phone, phone_code, email },
    },
    commonData: { loader },
  } = reduxStoreData;
  const reduxData = useSelector((state: any) => state);

  Konsole.log('discount', discount, id);

  const elements = useElements();
  const [isComplete, setIsComplete] = useState(false);
  const [isFutureSaveCard, setIsFutureSavedCard] = useState(true)

  //  return true if select delivery else return false for pickup
  const isDeliverySelect = useMemo(() => {
    return selectedType == 3;
  }, [selectedType]);

  // @@ true if select ASAP
  const isAsap = useMemo(() => {
    return (
      deliveryScheduleType == 1 &&
      IsNullUndefine(reduxData?.checkoutAddress?.selectedPickupDate)
    );
  }, [deliveryScheduleType, reduxData]);

  // console.log('isASAPisASAP', isAsap,reduxData)

  async function PaymentApi() {

    dispatch(SETLOADER(true));
    const data: any = {};
    data['first_name'] = first_name;
    data['last_name'] = last_name;
    data['name'] = `${first_name} ${last_name}`;
    data['email'] = email;
    data['phone'] = phone;
    data['iso_code'] = iso_code ? iso_code : 'GB';
    data['phone_code'] = phone_code;
    data['ip_address'] = '0.0.0.0';

    data['stripe_id'] = sessionStorage.getItem('secret_key_intent') || '';
    data['commission'] = (commissionFee || 0);
    data['discountAmount'] = discountAmount || 0;
    data['currency'] = 'GBP';
    data['final_price'] = totalPrice || 0;
    data['remaning_amount'] = remaining_amount || 0;
    data['sub_total'] = taxes?.sub_total || 0;
    data['total_price'] = totalPrice || 0;
    data['total_tax'] = taxes?.tax_amount || 0;
    data['payment_option'] = 'card';
    data['service_charge'] = (service_charge || 0) +(card_fees || 0);

    // data["id"] = isDeliverySelect ? id : "";
    data['id'] = sessionStorage.getItem('secret_key_intent') || '';
    data['address_lat'] = isDeliverySelect ? latitude || lattitude : '';
    data['address_long'] = isDeliverySelect ? longitude : '';
    data['complete_address'] = isDeliverySelect ? full_address : '';
    data['delivery_address'] = isDeliverySelect ? full_address : '';
    data['delivery_charges'] = isDeliverySelect ? deliveryCharge : null;
    data['house_no'] = isDeliverySelect ? house_no : '';
    data['near_land_mark'] = '';
    data['street_name'] = street_name || '';
    data['zip_code'] = zip_code || '';

    data['store_status'] = 3;
    data['store_type'] = 3;
    data['device_type'] = 'Web';
    data['order_category'] = selectedType; // 1 or 3 for delivery and pickup
    data['is_asap'] = isAsap ? 1 : 2; // 1 or 2 for asap or schedule
    data['order_comments'] = isDeliverySelect ? deliveryInstruction : '';
    data['order_note'] = deliveryNotes;
    data['notes'] = deliveryNotes;
    data['pre_order_status'] = 0;
    data['quantity'] = itemCount;
    data['items'] = items;
    data['selectedDate'] = isAsap ? '' : `${day} ${date}`;
    // data['selectedDate']=''
    data['time'] = isAsap ? getCurrentTime() : selectedPickupTime;

    let storeId = sessionStorage.getItem('store-id') || '';
    if (!storeId) {
      navigate('/menu');
      return;
    }


    // @@ order api for order
    const status = await orderApi(data);
    console.log('statusstatusstatus', status);
    if (status?.success) {
      // @@ check payment status after order success
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        redirect: 'if_required',
      });
      console.log(error, 'paymentIntentasdf', paymentIntent);
      // @@ if payment confirm than saved card api call
      if (paymentIntent && paymentIntent?.status == 'succeeded') {

        const cardData: any = {};
        cardData['payment_method_id'] = paymentIntent?.payment_method;
        cardData['store_id'] = storeId;
        cardData['stripe_connect_id'] = stripeConnectedId;
        cardData['is_save'] = isFutureSaveCard ? 1 : 0;
        const cardSaved = await saveCardDetails(cardData);
        // console.log('cardSavedcardSaved', cardSaved)
        afterPaymentSuccess();
        orderPlaceNRedirect(status, data);
      } else {
        afterPaymentSuccess();
        orderPlaceNRedirect(status, data);
      }
    }

    dispatch(SETLOADER(false));
  }

  // @@ order place and redirect
  function orderPlaceNRedirect(status: any, data: any) {
    sessionStorage.setItem("is_order_placed", 'true')
    navigate('/order-success', {
      state: { orderId: status?.order_id, data: JSON.parse(JSON.stringify(data)) }
    });
  }


  function afterPaymentSuccess() {
    setTimeout(() => {
      dispatch(CLEARCART());
      dispatch(CLEARALLORDER());
      dispatch(CLEARCHECKOUTADDRESS());
      dispatch(resetScheduleDeivery());
      sessionStorage.removeItem('items');
    }, 1500);
  }
  return (
    <>
      <div className="p-5">
        <p className="text-base font-bold mb-3">{t("Checkout.chooseAPaymentOption")}</p>
        {/* @@ stripe payment element display */}
        <PaymentElement
          id="payment-element"
          options={paymentElementOptions}
          // onReady={(e) => props.setPaymentMethod(Payment.CARD)}
          // onFocus={(e) => {
          //   setCardError('');
          //   props.setPaymentMethod(Payment.CARD);
          // }}
          onChange={(e) => {
            setIsComplete(e.complete);
          }}
          className="paymentField"
        />
      </div>
      {/* @@ confirm and pay button */}
      <div className="w-full md:static fixed bottom-0 p-3 md:px-5 md:pt-0 confirm-bottom">
        {/* @@END save card checkbox  */}
        <div className="mb-2 flex  gap-2" style={{ marginLeft: '0.2rem' }}>
          <input checked={isFutureSaveCard} onChange={(e: any) => setIsFutureSavedCard(e.target.checked)} type="checkbox" className="!block pt-1 accent-black shrink-0 login-margin" style={{ height: "0.9rem", width: "0.9rem" }} />
          <p className="textMd font-normal">
            {t("Payment.saved_card_future")}{" "}
          </p>
        </div>
        {/* @@END save card checkbox  */}
        {/* {loader ? (
          <LoaderButton />
        ) : (
          <button onClick={PaymentApi} disabled={!isComplete} className="bgBlue text-white text-center rounded-lg p-3 w-full font-bold text-base" style={{ marginTop: "0.5rem" }} type="button">
            <span className="textMd font-normal mr-2">{t("Checkout.confirmOrder")}</span>{' '}
            {ParseFloat(totalPrice || 0)}
          </button>
        )} */}

        <GlobalButton disabled={!isComplete} label={`${t("Checkout.confirmOrder")} ${"   -   "} ${ParseFloat(totalPrice || 0)}`}

          onClick={PaymentApi}
          loading={loader} />
      </div>

      {/* @@ confirm and pay button */}
    </>
  );
};

export default StripePayment;
